import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { HttpErrorHandler } from '../../shared/http-error-handler';
import { List } from '../../shared/list';

import { Ship } from '../../_models/ship';
import { ShipService } from '../../_services/ship.service';

@Component({
  selector: 'app-ships',
  templateUrl: './ship-list.component.html',
  styleUrls: ['./ship-list.component.sass'],
})
export class ShipListComponent extends List implements OnInit {
  errorMessage: string;

  // Mixins prototypes
  errorRouter: Router;

  constructor(private shipService: ShipService, private router: Router, private route: ActivatedRoute, protected httpErrorHandler: HttpErrorHandler) {
    super(shipService, new Ship(), router, route);
  }

  ngOnInit() {
    this.initList('ships', null);
  }

  deleteShip(ship: Ship) {
    this.shipService.delete(ship.id).subscribe(
      (empty) => this.list(this.currentPage),
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ships/ship-list/ship-list.component.ts